import dayjs from "dayjs";
import { HouseLatest } from "./hooks/useHouseLatest";
import { SenateLatest } from "./hooks/useSenateLatest";

export type CongressionalTrade = (HouseLatest | SenateLatest) & {
  chamber?: "house" | "senate";
};
export const tradeMemberName = (trade: CongressionalTrade) =>
  `${trade.firstName ?? ""} ${trade.lastName ?? ""}`.trim();
const normalizeName = (name: string) =>
  name
    .toLowerCase()
    .replace(/[^a-z\s]/g, "")
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 1)
    .join(" ");
const nameParts = (name: string) => normalizeName(name).split(" ");
const lastPart = (parts: string[]) => parts[parts.length - 1] ?? "";
export const memberSurname = (fmpName: string) =>
  lastPart(fmpName.trim().split(/\s+/));
// FMP's spelling of a member drifts over time (Gilbert Ray Cisneros became
// Gilbert Cisneros in July 2026), so match on surname and first given name
// rather than the whole string.
export const isMemberTrade = (trade: CongressionalTrade, fmpName: string) => {
  const expected = nameParts(fmpName);
  const first = nameParts(trade.firstName ?? "");
  return (
    normalizeName(trade.lastName ?? "") === lastPart(expected) &&
    first[0] === expected[0]
  );
};
export const tradeDirection = (type: string) => {
  const value = type.toLowerCase();
  if (value.includes("sale")) return "sale";
  if (value.includes("purchase")) return "purchase";
  return "other";
};
export const newestTradesFirst = (trades: CongressionalTrade[]) =>
  [...trades].sort((a, b) => {
    const aDate = dayjs(a.transactionDate);
    const bDate = dayjs(b.transactionDate);
    return (
      (bDate.isValid() ? bDate.valueOf() : 0) -
      (aDate.isValid() ? aDate.valueOf() : 0)
    );
  });
export const tradeDate = (value: string) =>
  dayjs(value).isValid() ? dayjs(value).format("MMM D, YYYY") : "—";
export const filingUrl = (link: string) => {
  try {
    const url = new URL(link);
    return ["https:", "http:"].includes(url.protocol) ? url.href : undefined;
  } catch {
    return undefined;
  }
};
